import React, { useLayoutEffect, useRef, useContext } from "react";
import rightArrow from "../../assets/svg/chevron.svg";
import Context from "../../context/context"; // Assuming you have a Context set up
import styles from "./SwipeableNav.module.scss";
import shave from "shave";
import moment from "moment";
import { importFiles } from "../../util/util-functions";

const lastX = 0;

const SwipableNav = ({
  items,
  videoWidth,
  handleTimestamp,
  currentTime,
  userScrolled,
  setUserScrolled,
  activeIndex,
  setActiveIndex,
  currentButtonIndex,
  setCurrentButtonIndex,
}) => {
  const filePaths = importFiles(
    import.meta.glob("../../assets/img/*", { eager: true })
  );
  const { windowWidth } = useContext(Context); // Assuming these values are provided by your Context

  const listEl = useRef();
  const listItems = useRef([]);

  const container = listEl;

  useLayoutEffect(() => {
    listItems.current.forEach((el, index) => {
      let listItemItem = el.children[1].children[0].children[0].innerText;
      let seconds = moment(listItemItem, "mm:ss").diff(
        moment().startOf("day"),
        "seconds"
      );
      let nextSeconds;
      if (el.nextSibling) {
        let nextListItem =
          el.nextSibling.children[1].children[0].children[0].innerText;
        nextSeconds = moment(nextListItem, "mm:ss").diff(
          moment().startOf("day"),
          "seconds"
        );
      }

      if (currentTime > seconds && currentTime < nextSeconds) {
        // If the user scrolled, don't auto scroll until next chapter
        if (userScrolled) {
          if (index !== activeIndex) {
            setActiveIndex(index);
            el.scrollIntoView({
              behavior: "smooth",
              block: "nearest",
              inline: "start",
            });
            return true;
          }
        } else {
          setActiveIndex(index);
          setCurrentButtonIndex(index);
          el.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "start",
          });
          setUserScrolled(false);
          return true;
        }
      }
    });
  }, [currentTime]);

  // useEffect(() => {
  //   let idx = listItems.current.length - 1;
  //   listItems.current[idx].scrollIntoView({
  //     behavior: "smooth",
  //     block: "nearest",
  //     inline: "start",
  //   });
  //   setActiveIndex(idx);

  // }, []);

  useLayoutEffect(() => {
    if (windowWidth < 768) {
      shave("#question", 40);
    } else {
      shave("#question", 79);
    }
  }, []);

  function goPrevious(e) {
    e.preventDefault();
    setUserScrolled(true);
    if (currentButtonIndex === 0) {
      return true;
    } else {
      listItems.current[currentButtonIndex - 1].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
      setCurrentButtonIndex(currentButtonIndex - 1);
    }
  }

  function goNext(e) {
    e.preventDefault();
    setUserScrolled(true);

    if (currentButtonIndex < listItems.current.length - 1) {
      listItems.current[currentButtonIndex + 1].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "start",
      });
      setCurrentButtonIndex(currentButtonIndex + 1);
    }
  }

  return (
    <nav aria-label="Article" className={styles.navListWrapper} id="nav">
      <button
        aria-hidden="true"
        onClick={(e) => goPrevious(e)}
        aria-label={"scroll to previous sectors"}
        className={` ${styles.buttons} ${styles.left} `}
      >
        <img className={styles.leftArrow} src={rightArrow} />
      </button>
      <div
        className={styles.mainScrollContainer}
        style={{ overflow: "scroll" }}
      >
        <ul id="navList" ref={listEl} className={styles.navList}>
          {items.map((navItem, i) => {
            return (
              <button
                ref={(el) => (listItems.current[i] = el)}
                href={navItem.url}
                key={navItem.question}
                aria-label={`Click to go to question, ${navItem.question}}`}
                onClick={() => handleTimestamp(navItem.time)}
                className={`${styles.navItem}`}
              >
                {navItem.image ? (
                  <div className={styles.imageContainer}>
                    <img
                      className={styles.image}
                      src={filePaths[navItem.image]}
                    />
                  </div>
                ) : (
                  <div className={styles.placeholderImg}></div>
                )}
                <div
                  className={`${styles.column} ${
                    activeIndex === i ? styles.active : ""
                  }`}
                >
                  <div className={styles.inline}>
                    <div>{navItem.time}</div>
                    <div className={styles.dividerLine}>&nbsp;|&nbsp;</div>
                    <div>{"Question " + (i + 1)}</div>
                  </div>

                  <p id="question" className={styles.question}>
                    {navItem.question}
                  </p>
                </div>
              </button>
            );
          })}
        </ul>
      </div>
      <button
        aria-hidden="true"
        onClick={(e) => goNext(e)}
        aria-label={"scroll to more sectors"}
        className={` ${styles.buttons} ${styles.right}  `}
      >
        <img className={styles.rightArrow} src={rightArrow} />
      </button>
    </nav>
  );
};

export default SwipableNav;
